import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Drawer,
  IconButton,
  Stack,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { brand, publicNavItems } from "../public.constants";

const Logo = () => (
  <Stack component={RouterLink} to="/" direction="row" spacing={1.2} alignItems="center" sx={{ color: "inherit", textDecoration: "none" }}>
    <Box
      sx={{
        width: 42,
        height: 42,
        borderRadius: 3,
        bgcolor: brand.primary,
        color: "white",
        display: "grid",
        placeItems: "center",
        fontWeight: 950,
        boxShadow: "0 12px 30px rgba(21, 88, 94, 0.25)"
      }}
    >
      VC
    </Box>
    <Stack spacing={0}>
      <Typography variant="h6" fontWeight={950} letterSpacing="-0.03em">
        {brand.name}
      </Typography>
      <Typography variant="caption" color="text.secondary" sx={{ lineHeight: 1 }}>
        Veterinary ERP SaaS
      </Typography>
    </Stack>
  </Stack>
);

const NavLinks = ({ onNavigate }) => {
  const location = useLocation();

  return (
    <Stack direction={{ xs: "column", md: "row" }} spacing={{ xs: 1, md: 0.5 }} alignItems={{ xs: "stretch", md: "center" }}>
      {publicNavItems.map((item) => {
        const active = location.pathname === item.path;
        return (
          <Button
            key={item.path}
            component={RouterLink}
            to={item.path}
            onClick={onNavigate}
            sx={{
              color: active ? brand.primary : "text.primary",
              fontWeight: active ? 900 : 700,
              borderRadius: 999,
              px: 2
            }}
          >
            {item.label}
          </Button>
        );
      })}
    </Stack>
  );
};

const PublicHeader = ({ variant = "default" }) => {
  const [open, setOpen] = useState(false);
  const minimal = variant === "minimal";

  return (
    <Box
      component="header"
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 20,
        bgcolor: "rgba(250, 248, 241, 0.84)",
        backdropFilter: "blur(18px)",
        borderBottom: "1px solid rgba(7, 23, 22, 0.08)"
      }}
    >
      <Container maxWidth="lg">
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ minHeight: 78 }}>
          <Logo />

          {!minimal ? (
            <Box sx={{ display: { xs: "none", md: "block" } }}>
              <NavLinks />
            </Box>
          ) : <Box sx={{ flex: 1 }} />}

          {!minimal ? (
            <Stack direction="row" spacing={1} alignItems="center" sx={{ display: { xs: "none", md: "flex" } }}>
              <Button component={RouterLink} to="/signin" variant="outlined" sx={{ borderRadius: 999 }}>
                Login
              </Button>
              <Button component={RouterLink} to="/signup" variant="contained" sx={{ borderRadius: 999, bgcolor: brand.primary }}>
                Signup
              </Button>
            </Stack>
          ) : null}

          {!minimal ? (
            <IconButton onClick={() => setOpen(true)} sx={{ display: { xs: "inline-flex", md: "none" } }} aria-label="Open navigation">
              <MenuIcon />
            </IconButton>
          ) : null}
        </Stack>
      </Container>

      {!minimal ? (
        <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
          <Box sx={{ width: 310, p: 3 }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
              <Logo />
              <IconButton onClick={() => setOpen(false)} aria-label="Close navigation">
                <CloseIcon />
              </IconButton>
            </Stack>
            <NavLinks onNavigate={() => setOpen(false)} />
            <Stack spacing={1.5} sx={{ mt: 3 }}>
              <Button component={RouterLink} to="/signin" variant="outlined" onClick={() => setOpen(false)}>
                Login
              </Button>
              <Button component={RouterLink} to="/signup" variant="contained" onClick={() => setOpen(false)}>
                Signup
              </Button>
            </Stack>
          </Box>
        </Drawer>
      ) : null}
    </Box>
  );
};

export default PublicHeader;
